module.exports = __webpack_public_path__ + "assets/img/debei.16c2f38f.png";